import { Typography, withStyles } from "@material-ui/core"

export const WhiteSpaceTypography = withStyles({
    root: {
        whiteSpace: "pre-wrap"
    }
})(Typography)
